import {Component, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AutoCompleteCompleteEvent} from "primeng/autocomplete";
import {UserValidatorService} from "projects/store/src/app/services/api/v1/user-validator.service";

@Component({
  selector: 'app-sales-additional-information-field-email',
  templateUrl: './sales-additional-information-field-email.component.html'
})
export class SalesAdditionalInformationFieldEmailComponent implements OnInit {
  commonDomains = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'icloud.com'];
  filteredDomains: string[] = [];

  @Input() form!: FormGroup;
  @Input() field: any;
  @Output() saveEvent = new EventEmitter();
  isSubmitted = signal(false);

  private userValidatorService = inject(UserValidatorService);

  ngOnInit() {
    this.form.addControl(`${this.field.key}`, new FormControl(this.field.value, {
      validators: [Validators.required, Validators.email],
      asyncValidators: [this.userValidatorService.emailServiceExistValidator(), this.userValidatorService.emailServiceStatusValid()],
      updateOn: 'blur'
    }));
    this.form.addControl(`${this.field.key}_checkbox`, new FormControl(null, [Validators.requiredTrue]));
  }

  save() {
    this.isSubmitted.set(true);
    if(this.form.get(this.field.key)?.errors === null) {
      this.saveEvent.emit({id: this.field.id, value: this.form.get(this.field.key)?.value});
    }
  }

  onDomainFilter(event: AutoCompleteCompleteEvent) {
    const query = event.query;

    if (query.includes('@')) {
      const [prefix, partialDomain] = query.split('@');
      this.filteredDomains = this.commonDomains
        .filter((domain) => domain.startsWith(partialDomain.toLowerCase()))
        .map((domain) => `${prefix}@${domain}`);
    } else {
      this.filteredDomains = [];
    }
  }

  get f() {
    return this.form.controls;
  }
}
